import API from 'api/hallomart';

/**
 * Constants
 */

export const FETCH_BRANCHES = 'branchs/FETCH_BRANCHES';
export const FETCH_BRANCHES_OK = 'branchs/FETCH_BRANCHES_OK';
export const FETCH_BRANCHES_FAILED = 'branchs/FETCH_BRANCHES_FAILED';

/**
 * Action creators
 */

export function fetchBranches(args = {}) {
  return async (dispatch, getState) => {
    const { user_id: merchant_id } = getState().user.user;

    try {
      dispatch({ type: FETCH_BRANCHES });
      const branches = await API.getMerchantBranches({
        ...args,
        per_page: 100,
        merchant_id,
      });

      dispatch({
        type: FETCH_BRANCHES_OK,
        payload: branches.data,
        totalPages: parseInt(branches.headers['x-wp-totalpages'], 10),
      });
    } catch (err) {
      dispatch({ type: FETCH_BRANCHES_FAILED, error: err.response || err.message });
    }
  };
}

/**
 * Reducers
 */

const initialState = {
  isLoading: false,
  error: false,
  errors: {},
  branches: [],
  totalPages: 1,
  isLoaded: false,
};

export default function branches(state = initialState, action) {
  switch (action.type) {
    case FETCH_BRANCHES:
      return {
        ...state,
        error: false,
        errors: {},
        isLoading: true,
        isLoaded: false,
      };

    case FETCH_BRANCHES_OK:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        branches: action.payload,
        totalPages: action.totalPages,
      };

    case FETCH_BRANCHES_FAILED:
      return {
        ...state,
        isLoading: false,
        error: true,
        errors: action.error,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/branches.js